import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../config.service';
import {
  AbsenceAutoTimeEntry,
  AbsenceAutoTimeEntryAdmin,
  ChronoUserPersonDateRange,
  PersonDateRange,
  TaskResult,
} from '../../models/client-models';
import { Observable } from 'rxjs';
import { AbsenceListItem } from '../../models/client-models';
import { TaskResultGeneric } from '../../models/task-result-generic';

const ABSENCE_ENDPOINT = 'absence';

@Injectable({
  providedIn: 'root',
})
export class AbsenceBackendService {
  constructor(private http: HttpClient) {}

  public getAbsences(filterValue: number) {
    return this.http.get<AbsenceListItem[]>(
      AppConfig.settings.backend.url +
        ABSENCE_ENDPOINT +
        '?idAbsence=' +
        filterValue
    );
  }

  public createAbsences(
    absenceRange: AbsenceAutoTimeEntry
  ): Observable<TaskResult> {
    return this.http.post<TaskResult>(
      AppConfig.settings.backend.url + ABSENCE_ENDPOINT,
      absenceRange
    );
  }

  public createAbsencesAsAdmin(
    absenceRange: AbsenceAutoTimeEntryAdmin
  ): Observable<TaskResult> {
    return this.http.post<TaskResult>(
      AppConfig.settings.backend.url + ABSENCE_ENDPOINT + '/chronoUser',
      absenceRange
    );
  }

  public checkOverdraft(req: {
    idPerson: number;
    startDate: string;
    endDate: string;
    absenceId: number;
    requestedHours?: number;
    isNewEntry?: boolean;
  }) {
    return this.http.post<TaskResultGeneric<any>>(
      AppConfig.settings.backend.url + 'absence/check-overdraft',
      req
    );
  }

  public deleteAbsence(absenceRange: PersonDateRange): Observable<TaskResult> {
    const options = {
      header: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: absenceRange,
    };
    return this.http.request<TaskResult>(
      'delete',
      AppConfig.settings.backend.url + ABSENCE_ENDPOINT,
      options
    );
  }

  public deleteAbsenceAsChronoUser(absenceRange: ChronoUserPersonDateRange) {
    const options = {
      header: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: absenceRange,
    };
    return this.http.request<TaskResult>(
      'delete',
      AppConfig.settings.backend.url + ABSENCE_ENDPOINT + '/chronoUser',
      options
    );
  }
}
